import { render, staticRenderFns } from "./loanInfoMore.vue?vue&type=template&id=edb8a7b4&scoped=true&"
import script from "./loanInfoMore.vue?vue&type=script&lang=ts&"
export * from "./loanInfoMore.vue?vue&type=script&lang=ts&"
import style0 from "./loanInfoMore.vue?vue&type=style&index=0&id=edb8a7b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb8a7b4",
  null
  
)

export default component.exports